{
  "version": 1,
  "asset_id": "e8ea2b2b-ae8b-4225-ad83-8e109455ea35",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e8ea2b2b-ae8b-4225-ad83-8e109455ea35/ind-legal-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e8ea2b2b-ae8b-4225-ad83-8e109455ea35/ind-legal-640.webp",
  "original_filename": "ind-legal-640.webp",
  "size": 5126,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:05Z"
}
